module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.2313/img/app-marketplace-network-2x.png"